/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-wrap-multilines */
import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import { useHistory, useLocation } from 'react-router';
import PropTypes from 'prop-types';
import { useInjectSaga } from '../../utils/injectSaga';
import saga from './saga';
import { useInjectReducer } from '../../utils/injectReducer';
import reducer from './reducer';
import { ModalWindow } from '../../semantic-ui/components/modal-window';
import ModalFooterButtons from '../../semantic-ui/components/modal-window/modal-footer-buttons';

import { getReqInfoAction, resetStateAction, sendCargoExpressDeliveryFormAction } from './actions';
import {
	getActiveReqIdSelector,
	getIsReqInfoLoadingSelector,
	getIsModalShownSelector,
	getIsReqInfoSendingSelector,
} from './selectors';
import { FORM_NAME } from './constants';
import { removeModalQuery } from '../../utils/removeModalQuery';

import { CargoExpressDeliveryForm } from './components/cargo-express-delivery-form';
import cancelModal from '../../utils/cancelModal';
import closeModal from '../../utils/closeModal';

const CargoExpressDeliveryWrapper = ({
	onGetReqInfo,
	isReqInfoLoading,
	isReqInfoSending,
	onResetState,
	isModalShown,
	activeReqId,
	onFormSubmit,
	onSendCargoExpressDeliveryForm,
}) => {
	if (!isModalShown) return null;
	useInjectSaga({ key: 'cargoExpressDeliveryModalSaga', saga });
	useInjectReducer({ key: 'cargoExpressDeliveryModalReducer', reducer });

	const { search, pathname } = useLocation();

	const query = new URLSearchParams(search);

	const history = useHistory();

	useEffect(() => {
		return () => onResetState();
	}, []);

	useEffect(() => {
		if (activeReqId) onGetReqInfo(activeReqId);
	}, [activeReqId]);

	const handleModalCancel = () => {
		cancelModal(query);
		onResetState();
		history.push(`${pathname}?${query}`);
	};

	const handleModalClose = () => {
		closeModal(query);
		onResetState();
		history.push(`${pathname}?${query}`);
	};

	const handleFormSubmit = async () => {
		await onFormSubmit(FORM_NAME);
		onSendCargoExpressDeliveryForm({
			activeReqId,
			redirect: handleModalClose,
			searchQuery: removeModalQuery(query.toString()),
		});
	};

	const handleKeyDown = e => {
		if (e.key === 'Enter' && e.shiftKey === false) {
			handleFormSubmit();
		}
	};

	return (
		<ModalWindow
			isModalShown={isModalShown}
			onKeyDown={handleKeyDown}
			onClose={handleModalClose}
			headerText="Форма доставки груза"
			navItems={[]}
			modalContent={<CargoExpressDeliveryForm />}
			style={{ width: '752px' }}
			actionButtons={[{ type: 'close', onClick: handleModalClose, text: 'cargo-express-delivery' }]}
			footerButtons={
				<ModalFooterButtons
					leftButtons={[]}
					rightButtons={[
						{
							onClick: () => handleFormSubmit(),
							text: 'Груз доставлен',
							color: 'primary',
							disabled: isReqInfoLoading || isReqInfoSending,
							loading: isReqInfoSending,
						},
						{
							onClick: handleModalCancel,
							text: 'Закрыть',
							color: 'secondary',
							disabled: isReqInfoSending,
						},
					]}
				/>
			}
		/>
	);
};

const mapStateToProps = createStructuredSelector({
	isReqInfoLoading: getIsReqInfoLoadingSelector(),
	isReqInfoSending: getIsReqInfoSendingSelector(),
	isModalShown: getIsModalShownSelector(),
	activeReqId: getActiveReqIdSelector(),
});

const mapDispatchToProps = {
	onGetReqInfo: getReqInfoAction,
	onResetState: resetStateAction,
	onFormSubmit: submit,
	onSendCargoExpressDeliveryForm: sendCargoExpressDeliveryFormAction,
};

const CargoExpressDeliveryModal = connect(mapStateToProps, mapDispatchToProps)(CargoExpressDeliveryWrapper);

CargoExpressDeliveryWrapper.propTypes = {
	onGetReqInfo: PropTypes.func.isRequired,
	isReqInfoLoading: PropTypes.bool.isRequired,
	isReqInfoSending: PropTypes.bool.isRequired,
	onResetState: PropTypes.func.isRequired,
	isModalShown: PropTypes.bool.isRequired,
	activeReqId: PropTypes.string,
	onFormSubmit: PropTypes.func.isRequired,
	onSendCargoExpressDeliveryForm: PropTypes.func.isRequired,
};

export default CargoExpressDeliveryModal;
